export default "__VITE_ASSET__DEIe4Iks__"